import { WguEventBus } from '../WguEventBus.js'

/**
 * Mixin, which binds the OL map to the target component.
 * Executes the onMapBound function of the target component, if available.
 */
export const Mapable = {
  created () {
    // Always listen to map mount/unmount.
    // Reason: components can be created while $map exists, but the map can later
    // be destroyed/re-created when navigating between views. If we don't listen
    // permanently we may keep a stale map reference (often with cleared layers).

    this._mapableOnMounted = (olMap) => {
      this.map = olMap;

      if (this.onMapBound) {
        this.onMapBound();
        this.unbound = false;
      }
    };

    this._mapableOnUnmounted = (olMap) => {
      // Only unbind if the unmounted map is the one we are currently using.
      // If no payload is provided, do not unbind to avoid accidental nulling.
      if (!olMap) return;
      if (this.map && olMap !== this.map) return;

      this.map = null;
      if (this.onMapUnbound) {
        this.onMapUnbound();
        this.unbound = true;
      }
    };

    WguEventBus.$on('ol-map-mounted', this._mapableOnMounted);
    WguEventBus.$on('ol-map-unmounted', this._mapableOnUnmounted);

    // If the OL map is already mounted, apply it immediately (but keep listeners).
    if (this.$map) {
      this.map = this.$map;
      if (this.onMapBound) {
        this.onMapBound();
        this.unbound = false;
      }
    }
  },
  beforeDestroy () {
    if (this._mapableOnMounted) {
      WguEventBus.$off('ol-map-mounted', this._mapableOnMounted);
      this._mapableOnMounted = null;
    }
    if (this._mapableOnUnmounted) {
      WguEventBus.$off('ol-map-unmounted', this._mapableOnUnmounted);
      this._mapableOnUnmounted = null;
    }
  }
};
